import { Box, Button, Link, List, ListItem, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHmrcOauthUrlRequest } from 'redux/reducers/settings/reducer';
import {
	getHmrcOauthUrl,
	getIntegrations,
	getIntegrationsLoader,
} from 'redux/reducers/settings/selectors';
import { IntegrationsPlatform } from 'redux/reducers/integrations/constants';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { PopupScreensaver } from './PopupScreensaver';

export const Step4HMRC: FC = () => {
	const dispatch = useDispatch();
	const integrations = useSelector(getIntegrations)?.integrations;
	const integrationsLoader = useSelector(getIntegrationsLoader);
	const location = useLocation();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);

	const [popup, setPopup] = useState<Window | null>(null);
	const hmrcUrl = useSelector(getHmrcOauthUrl);

	// console.log('Step2HMRC popup', popup);

	useEffect(() => {
		if (hmrcUrl === null) return;
		const w = 1000;
		const h = 1000;
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth
			? window.innerWidth
			: document.documentElement.clientWidth
				? document.documentElement.clientWidth
				: window.screen.width;
		const height = window.innerHeight
			? window.innerHeight
			: document.documentElement.clientHeight
				? document.documentElement.clientHeight
				: window.screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;

		const params = `width=${w / systemZoom}, height=${h / systemZoom}, 
      top=${top}, 
      left=${left},toolbar=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,copyhistory=no`;

		const newPopup = window.open(hmrcUrl?.oauthUrl, '', params);
		setPopup(newPopup);
	}, [hmrcUrl]);

	// useEffect(() => {
	// 	if (!popup) {
	// 		return;
	// 	}

	// 	const timer = setInterval(() => {
	// 		if (!popup) {
	// 			timer && clearInterval(timer);
	// 			return;
	// 		}
	// 		if (!popup?.location) return;
	// 		// if (!popup?.location?.href) return;
	// 		// const currentUrl = popup.location.href;
	// 		// if (!currentUrl) {
	// 		// 	return;
	// 		// }
	// 		// const { searchParams } = new URL(currentUrl);
	// 		// const code = searchParams.get('code');

	// 		// if (code) {
	// 		// 	popup.close();
	// 		// 	console.log(`The popup URL has URL code param = ${code}`);
	// 		// 	// YourApi.endpoint(code)
	// 		// 	// 	.then(() => {
	// 		// 	// 		// change UI to show after the code was stored
	// 		// 	// 	})
	// 		// 	// 	.catch(() => {
	// 		// 	// 		// API error
	// 		// 	// 	})
	// 		// 	// 	.finally(() => {
	// 		// 	// 		// clear timer at the end
	// 		// 	// 		setPopup(null);
	// 		// 	// 		timer && clearInterval(timer);
	// 		// 	// 	});
	// 		// }
	// 		if (popup.closed) {
	// 			console.log('popup.closed');
	// 			setPopupOpened(false);
	// 			setPopup(null);
	// 			timer && clearInterval(timer);
	// 		}
	// 	}, 500);
	// }, [popup]);

	// useEffect(() => {
	// 	if (popup?.location.href.includes('easproject.com')) {
	// 		console.log('popup', popup);
	// 		setPopupOpened(false);
	// 	}
	// }, [popup]);

	// useInterval(
	// 	() => {
	// 		if (!!popup && popup.closed) {
	// 			console.log('popup');
	// 			// setPopupOpened(false);
	// 			setPopupOpenedTest(false);
	// 		}
	// 	},
	// 	popupOpened ? 1000 : null,
	// );

	// useEffect(() => {
	// 	console.log('popup', popup);
	// 	if (!!popup && popup.closed) {
	// 		console.log('setPopupClosed');
	// 		setPopupOpened(false);
	// 	} else if (popup) {
	// 		console.log('setPopupOpened');
	// 		setPopupOpened(true);
	// 	}
	// }, [popup]);

	// const int = setInterval(() => {
	// 	if (popup && popup.closed) {
	// 		setPopupOpened(false);
	// 		clearInterval(int);
	// 	}
	// }, 1000);

	// useEffect(() => {
	// 	window.open('https://www.gov.uk/guidance/sign-up-for-making-tax-digital-for-vat', '', '');
	// }, []);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				// alignItems: 'center',
				// justifyContent: 'center',
				mt: '20px',
				gap: '40px',
			}}
		>
			{!!popup && (
				<PopupScreensaver popup={popup} />
				// <Button onClick={handleTest}>TEST</Button>
			)}
			{/* <Button onClick={handleTest}>TEST</Button> */}

			<Box>
				{integrationsLoader && (
					<Typography
						component="p"
						sx={{
							fontSize: '1.2rem',
							fontStyle: 'italic',
							fontWeight: '550',
							color: 'text.secondary',
						}}
					>
						Please wait...
					</Typography>
				)}
				{popup !== null &&
					navigateParams.closed === 'true' &&
					!integrationsLoader &&
					((integrations?.findIndex(
						(integration) => integration.platform === (IntegrationsPlatform.HMRC as string),
					) ?? -1) > -1 ? (
						<Typography
							component="p"
							sx={{
								mt: '20px',
								fontSize: '1.2rem',
								fontStyle: 'italic',
								fontWeight: '550',
								color: 'success.main',
							}}
						>
							Signed in to HMRC and connected to the store successfully.
						</Typography>
					) : (
						<Typography
							component="p"
							sx={{
								mt: '20px',
								fontSize: '1.2rem',
								fontStyle: 'italic',
								fontWeight: '550',
								color: 'error.main',
							}}
						>
							You did not succeed in connecting to the HMRC MTD solution.
							<br />
							Please, ensure that you have access to your HMRC account and that VAT service is
							properly connected.
						</Typography>
					))}
			</Box>
		</Box>
	);
};
